import { apiRequest } from "./apiClient";

// Admin bildirim geçmişi: gönderilen son kayıtlar, otomasyon sonuçları ve sistem/aile duyuruları.
export async function bildirimGecmisiniGetir(familyId = null, limit = 100) {
  try {
    const params = new URLSearchParams();
    if (familyId) params.set("familyId", familyId);
    params.set("limit", String(limit || 100));
    const data = await apiRequest(`/notifications/admin/history?${params.toString()}`);
    return data?.items || [];
  } catch (err) {
    console.warn("[bildirimGecmisiniGetir] Geçmiş alınamadı:", err);
    return [];
  }
}

export async function bildirimAlicilariniGetir(notificationId, offset = 0, limit = 100) {
  const params = new URLSearchParams({ offset:String(offset), limit:String(limit) });
  const data = await apiRequest(`/notifications/admin/history/${encodeURIComponent(notificationId)}/recipients?${params}`);
  return { items:data?.items || [], total:Number(data?.total || 0) };
}

export async function tumBildirimGecmisiniGetir({
  cursor = null,
  limit = 100,
  period = "30d",
  category = "all",
  status = "all",
  channel = "all",
  search = "",
} = {}) {
  const params = new URLSearchParams({
    limit: String(Math.min(100, Math.max(1, Number(limit || 100)))),
    period,
    category,
    status,
    channel,
  });
  if (cursor) params.set("cursor", cursor);
  if (String(search || "").trim()) params.set("search", String(search).trim());
  const data = await apiRequest(`/notifications/admin/notification-history?${params}`);
  return { items:data?.items || [], nextCursor:data?.nextCursor || null };
}

export async function tumBildirimGecmisiAlicilariniGetir(groupId, offset = 0, limit = 100) {
  const params = new URLSearchParams({ offset:String(offset), limit:String(limit) });
  const data = await apiRequest(`/notifications/admin/notification-history/${encodeURIComponent(groupId)}/recipients?${params}`);
  return { items:data?.items || [], total:Number(data?.total || 0) };
}

export async function sonSaatlerdekiPushlariGetir(hours = 24, offset = 0, limit = 100) {
  const params = new URLSearchParams({ hours:String(hours), offset:String(offset), limit:String(limit) });
  const data = await apiRequest(`/notifications/admin/automation/deliveries?${params}`);
  return { items:data?.items || [], total:Number(data?.total || 0) };
}
